//http://jsfiddle.net/99ycK/1/
import React from 'react';

export const ColorPaletteDisplay = ({ palette }) => {
  return (
    <div
      style={{
        // marginLeft: 10,
        borderRadius: 3,
        width: 70,
        height: 20,
        display: 'flex',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: '50%',
          background: `linear-gradient(to right, ${palette.c0}, ${palette.c1})`,
        }}
      ></div>
      <div
        style={{
          width: '50%',
          background: `linear-gradient(to right, ${palette.c1}, ${palette.c2})`,
          right: 0,
        }}
      ></div>
    </div>
  );
};

var Color = function (hexOrObject) {
  var obj;
  if (hexOrObject instanceof Object) {
    obj = hexOrObject;
  } else {
    obj = LinearColorInterpolator.convertHexToRgb(hexOrObject);
  }
  this.r = obj.r;
  this.g = obj.g;
  this.b = obj.b;
  this.a = obj.a;
};
Color.prototype.asRgbCss = function () {
  return `rgba(${this.r}, ${this.g}, ${this.b}${
    this.a != null ? `, ${this.a}` : ''
  })`;
};

var LinearColorInterpolator = {
  // convert 6-digit hex to rgb components;
  // accepts with or without hash ("335577" or "#335577")
  convertHexToRgb: function (hex) {
    var match = hex.replace(/#/, '').match(/.{1,2}/g);
    return new Color({
      r: parseInt(match[0], 16),
      g: parseInt(match[1], 16),
      b: parseInt(match[2], 16),
      a: match[3] != null ? parseInt(match[3], 16) / 256 : null,
    });
  },
  // left and right are colors that you're aiming to find
  // a color between. Percentage (0-100) indicates the ratio
  // of right to left. Higher percentage means more right,
  // lower means more left.
  findColorBetween: function (left, right, percentage) {
    var newColor = {};
    var components = ['r', 'g', 'b', 'a'];
    for (var i = 0; i < components.length; i++) {
      var c = components[i];
      if (left[c] == null || right[c] == null) continue;
      // newColor[c] = Math.round(left[c] + (right[c] - left[c]) * percentage / 100);
      const value = left[c] + ((right[c] - left[c]) * percentage) / 100;
      newColor[c] = c === 'a' ? value : Math.round(value);
    }
    return new Color(newColor);
  },
};

function getColorsForPalette(
  palette = { c0: '#dd514c', c1: '#faa732', c2: '#5eb95e' }
) {
  return {
    c0: new Color(palette.c0),
    c1: new Color(palette.c1),
    c2: new Color(palette.c2),
  };
}

export function calculateColor(palette, min, max, mid, value) {
  const { c0, c1, c2 } = getColorsForPalette(palette);
  const hasSingleValue = min === max;

  const valuePct = hasSingleValue
    ? 100
    : (1 - (max - value) / (max - min)) * 100;

  var left, right, percentage;
  if (!hasSingleValue && value < mid) {
    left = c0;
    right = c1;
    percentage = valuePct * 2;
  } else {
    left = c1;
    right = c2;
    percentage = (valuePct - 50) * 2;
  }

  return LinearColorInterpolator.findColorBetween(
    left,
    right,
    percentage
  ).asRgbCss();
}
